// plugins/socketio.js
import Vue from "vue";
import io from "socket.io-client";
import GLOBAL from "../constants/global";

const socket = io(GLOBAL.baseURL); // Replace with your server URL

Vue.prototype.$socket = socket;
